import React from 'react'

export default function FormManage({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2584_1815)">
        <path d="M29.333 8H2.66634C2.31283 8.00035 1.97389 8.14094 1.72392 8.39091C1.47395 8.64089 1.33336 8.97982 1.33301 9.33333V13.3333C1.33336 13.6868 1.47395 14.0258 1.72392 14.2758C1.97389 14.5257 2.31283 14.6663 2.66634 14.6667H29.333C29.6865 14.6663 30.0255 14.5257 30.2754 14.2758C30.5254 14.0258 30.666 13.6868 30.6663 13.3333V9.33333C30.666 8.97982 30.5254 8.64089 30.2754 8.39091C30.0255 8.14094 29.6865 8.00035 29.333 8ZM29.333 13.3333H2.66634V9.33333H29.333V13.3333ZM29.333 22.6667H2.66634C2.31283 22.667 1.97389 22.8076 1.72392 23.0576C1.47395 23.3076 1.33336 23.6465 1.33301 24V28C1.33336 28.3535 1.47395 28.6924 1.72392 28.9424C1.97389 29.1924 2.31283 29.333 2.66634 29.3333H29.333C29.6865 29.333 30.0255 29.1924 30.2754 28.9424C30.5254 28.6924 30.666 28.3535 30.6663 28V24C30.666 23.6465 30.5254 23.3076 30.2754 23.0576C30.0255 22.8076 29.6865 22.667 29.333 22.6667ZM29.333 28H2.66634V24H29.333V28ZM13.333 18.6667V20H2.66634V18.6667H13.333ZM2.66634 4H13.333V5.33333H2.66634V4Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_2584_1815">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
